import { render, staticRenderFns } from "./add-edit-disclaimer-modal.vue?vue&type=template&id=2c75daa6&"
import script from "./add-edit-disclaimer-modal.vue?vue&type=script&lang=js&"
export * from "./add-edit-disclaimer-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-disclaimer-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "add-edit-disclaimer-modal.vue"
export default component.exports